import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

/*Call Plugins*/
import '@/complements/fontawesome'

// Vuesax Component Framework
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

import i18n from './complements/i18n'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// Interceptor para agregar el token a las llamadas al API
import './api/interceptors/jwtToken'
// Interceptor para redirigir al login cuando caduque el JWT
import './api/interceptors/responses'

//Complements
import './complements/veevalidate'
Vue.config.devtools = true
Vue.config.productionTip = process.env.VUE_APP_DEVTOOLS
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

